<template>
  <section class="feature_part">
    <b-container>
      <b-row>
        <b-col lg="3" xl="3" sm="6" class="align-self-center">
          <div class="single_feature_text">
            <slot name="th1"/>
            <slot name="th2"/>
            <slot name="th3"/>
          </div>
        </b-col>
        <b-col lg="9">
          <slot name="pl-1"/>
        </b-col>

      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "FeatureCards",
};
</script>

<style scoped>
.feature_part .single_feature_part {
  border: 1px solid #f0f4f6;
  text-align: center;
  -webkit-transition: 0.6s;
  transition: 0.6s;
}

.feature_part .single_feature_part span {
  margin-bottom: 30px;
  display: inline-block;
  position: relative;
  z-index: 1;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  text-align: center;
  background-color: #f0f4f6;
  display: inline-block;
  line-height: 80px;
  transition: all ease-in-out 0.6s;
}

.feature_part .single_feature_part span svg {
  color: #0c2e60;
  font-size: 24px;
  transition: all ease-in-out 0.6s;
}

.single_feature:hover span {
  background-image: linear-gradient(
      to left,
      var(--primary) 0%,
      var(--secondary) 51%,
      var(--primary) 100%
  );
  background-size: 200% auto;
  background-position: right center;
}

.single_feature:hover span svg {
  color: #fff;
}

.feature_part .single_feature:hover .single_feature_part {
  border: 1px solid var(--primary);
}

.single_feature_part p {
  color: #7f7f7f;
  line-height: 1.8;
  font-size: 15px;
  text-align: center;
}

@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .feature_part .single_feature_part {
    margin-top: 25px;
  }
}

@media (max-width: 576px) {
  .feature_part .single_feature_part {
    padding: 25px 10px;
    margin-top: 25px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .feature_part .single_feature_part {
    padding: 30px 15px;
    margin-top: 25px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .feature_part .single_feature_part {
    padding: 30px 25px;
    margin-top: 25px;
  }
}
</style>